<template>
  <div class="payment-provider-card" @click="$emit('select')">
    <img
      v-if="logo"
      :src="logo"
      alt="provider logo"
      class="payment-provider-card__logo"
    />

    <div class="payment-provider-card__description">
      <p
        v-if="description"
      >
        {{ description }}
      </p>
    </div>

    <button class="payment-provider-card__btn" type="button">Выбрать</button>
  </div>
</template>

<script setup lang="ts">
defineProps({
  logo: String,
  description: String
})

defineEmits(['select'])
</script>

<style scoped lang="scss">
.payment-provider-card {
  border: 2px solid transparent;
  border-radius: 20px;
  padding: 20px;
  transition: all 0.2s ease;
  background: #f7f9fa;
  cursor: pointer;
  display: flex;
  column-gap: 30px;
  align-items: center;
  row-gap: 8px;

  @include mobile {
    flex-direction: column;
  }
}

.payment-provider-card:hover {
  border: 2px solid #cbdbf7;
  background-color: #f3f5f7;
}


.payment-provider-card__logo {
  max-height: 40px;
  width: 100%;
  object-fit: contain;
  max-width: 110px;
}

.payment-provider-card__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #000;
  flex: 1;
}

.payment-provider-card__btn {
  font-weight: 400;
  font-size: 15px;
  line-height: 133%;
  color: rgba(0, 0, 0, 0.85);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 44px;
  border: none;
  background-color: #fff;
  margin-left: auto;
  cursor: pointer;
  flex-shrink: 0;

  @include mobile {
    width: 100%;
  }

  &:hover {
    opacity: 0.8;
  }
}
</style>